import { FieldSortExpressionOrderEnum } from '@rtkwlf/asset-data-service';
import snakeCase from 'lodash/snakeCase';

import type { GridSortModel } from '@packages/fenrir/components/datagrid';

import type { AssetsTableColumnId } from '../../asset-table.constants';

const sortableFields: AssetsTableColumnId[] = [
  'name',
  'category',
  'risk.count',
  'legacyDeviceIds',
  'risk.score',
  'importance',
  'risk.lastSuccessfulScanned',
  'lastSeenTime',
];

const getSortName = (id: string) => id.split('.').map(snakeCase).join('.');

export const getSortParam = (sort: GridSortModel) =>
  sort
    .filter(({ field }) =>
      sortableFields.includes(field as AssetsTableColumnId),
    )
    .map(({ field, sort }) => ({
      field: {
        name: getSortName(field),
      },
      order:
        sort === 'asc'
          ? FieldSortExpressionOrderEnum.Asc
          : FieldSortExpressionOrderEnum.Desc,
    }));
